@import 'styles/mixins';
@import 'styles/variables';

.bodyText {
  @include lg-regular;
  color: $black;
}

.emails {
  margin: 24px 0;
  overflow: auto;
  max-height: 223px;
  padding: 16px;
  border: 1px solid var(--neutral-10);
  border-radius: 7px;

  .email {
    @include ui-md-text;

    align-items: center;
    color: var(--neutral-50);
    display: flex;
    column-gap: 8px;
    row-gap: 28px;
  }

  .email + .email {
    margin-top: 20px;
  }
}
